<script>
import { GraphQLClient } from "graphql-request";

export default {
  props: {
    gql: String,
  },
  data() {
    return {
      data: null,
      error: null,
      loading: false,
    };
  },
  computed: {
    config() {
      return this.$store?.state?.config;
    },
    gqlOptions() {
      if (!this.config?.token) return;
      return {
        headers: {
          authorization: `Bearer ${this.config.token}`,
        },
      };
    },
    gqlClient() {
      if (!this.config?.endpoint) return;
      return new GraphQLClient(this.config.endpoint, this.gqlOptions);
    },
  },
  methods: {
    async gqlRequest(params = {}) {
      try {
        this.loading = true;
        if (this.error) this.error = null;
        this.data = await this.gqlClient.request(this.gql, params);
        this.$emit("on:result", this.data);
      } catch (error) {
        this.loading = true;

        this.error = JSON.stringify(error, undefined, 2);
        this.$emit("on:error", this.error);
        console.error(JSON.stringify(error, undefined, 2));
      } finally {
        this.loading = false;
      }
    },
  },
  render() {
    return this.$scopedSlots.default({
      data: this.data,
      error: this.error,
      loading: this.loading,
      gqlRequest: this.gqlRequest,
    });
  },
};
</script>
